package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AccentBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatTile
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.Recipe
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.core.model.localizeDigits
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_find_ingredients
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_ingredients_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_like_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_minutes
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipe_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipe_not_found
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_action
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_other
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_message
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_start_cooking
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_stat_cook
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_stat_difficulty
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_stat_prep
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_stat_serves
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_steps_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_story_title
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/** Stateful entry for the recipe detail (`/gems/recipe/{id}`). */
@Composable
fun RecipeDetailRoute(
    recipeId: String,
    onBack: () -> Unit,
    onStartCooking: () -> Unit,
    onFindIngredients: (query: String) -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: RecipeDetailViewModel = koinViewModel(parameters = { parametersOf(recipeId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val shareService = koinInject<ShareService>()
    val shareConfig = koinInject<ShareConfig>()
    val lang = AppTheme.language
    val shareTemplate = stringResource(Res.string.gems_share_message)

    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) {
            viewModel.consumeSignInGate()
            onRequireSignIn()
        }
    }
    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == GemReportStatus.SignInRequired) {
            viewModel.resetReport()
            onRequireSignIn()
        }
    }

    RecipeDetailScreen(
        state = state,
        onBack = onBack,
        onStartCooking = onStartCooking,
        onFindIngredients = onFindIngredients,
        onToggleLike = viewModel::toggleLike,
        onToggleSave = viewModel::toggleSave,
        onShare = { recipe ->
            shareService.share(
                shareTemplate
                    .replace("%1\$s", recipe.title.resolve(lang))
                    .replace("%2\$s", shareConfig.recipeLink(recipe.id)),
            )
        },
        onReport = viewModel::report,
        onResetReport = viewModel::resetReport,
        modifier = modifier,
    )
}

/**
 * Recipe detail — Stitch ID pending (generation timed out 2026-07-19); built from
 * `docs/HIDDEN_GEMS_PLAN.md` §6: hero image with floating back/share/save, title + region badge +
 * like, story card, stat tiles, tappable ingredients checklist, numbered steps, "Start cooking"
 * and "Find ingredients near you" CTAs, and a report link.
 */
@Composable
fun RecipeDetailScreen(
    state: RecipeDetailUiState,
    onBack: () -> Unit,
    onStartCooking: () -> Unit,
    onFindIngredients: (query: String) -> Unit,
    onToggleLike: () -> Unit,
    onToggleSave: () -> Unit,
    onShare: (Recipe) -> Unit,
    onReport: (reason: String) -> Unit,
    onResetReport: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val lang = AppTheme.language
    var showReportSheet by remember { mutableStateOf(false) }

    when {
        state.loading -> {
            LoadingState(modifier = modifier.fillMaxSize())
            return
        }
        state.recipe == null -> {
            Column(modifier = modifier.fillMaxSize().background(AppTheme.colors.background).statusBarsPadding().navigationBarsPadding()) {
                AppIconButton(
                    iconName = "arrow_back",
                    contentDescription = stringResource(Res.string.gems_back_a11y),
                    onClick = onBack,
                    tint = AppTheme.colors.onSurface,
                    modifier = Modifier.padding(AppTheme.spacing.md),
                )
                EmptyState(title = stringResource(Res.string.gems_recipe_not_found))
            }
            return
        }
    }
    val recipe = state.recipe ?: return
    // Ingredient checklist is screen-local UI state (survives rotation, resets on nav — by
    // design). Stored as a List because Bundle-backed savers can't hold a Set.
    var checkedIngredients by rememberSaveable(recipe.id) { mutableStateOf(listOf<Int>()) }

    Column(
        modifier = modifier
            .fillMaxSize()
            .background(AppTheme.colors.background)
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        // ── Hero image with floating actions (back at start; share/save at end — RTL mirrors).
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .aspectRatio(HERO_ASPECT_RATIO),
        ) {
            BusinessCover(
                imageUrl = recipe.imageUrl,
                iconName = "skillet",
                contentDescription = stringResource(Res.string.gems_recipe_image_a11y),
            )
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .statusBarsPadding().navigationBarsPadding()
                    .padding(AppTheme.spacing.md),
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                FloatingActionIcon(
                    iconName = "arrow_back",
                    contentDescription = stringResource(Res.string.gems_back_a11y),
                    onClick = onBack,
                )
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                    FloatingActionIcon(
                        iconName = "share",
                        contentDescription = stringResource(Res.string.gems_share_a11y),
                        onClick = { onShare(recipe) },
                    )
                    FloatingActionIcon(
                        iconName = "bookmark",
                        contentDescription = stringResource(Res.string.gems_save_a11y),
                        onClick = onToggleSave,
                        filled = state.saved,
                        tint = if (state.saved) AppTheme.colors.primary else AppTheme.colors.onSurface,
                    )
                }
            }
        }

        Column(
            modifier = Modifier
                .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                .fillMaxWidth()
                .padding(horizontal = AppTheme.spacing.lg)
                .padding(top = AppTheme.spacing.lg, bottom = AppTheme.spacing.xl),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        ) {
            // ── Title + region + like.
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                ) {
                    Text(
                        text = recipe.title.resolve(lang),
                        style = AppTheme.typography.headlineLg,
                        color = AppTheme.colors.onSurface,
                    )
                    AccentBadge(label = recipe.region.label())
                }
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    AppIconButton(
                        iconName = "favorite",
                        contentDescription = stringResource(Res.string.gems_like_a11y),
                        onClick = onToggleLike,
                        filled = state.liked,
                        tint = if (state.liked) AppTheme.colors.error else AppTheme.colors.onSurfaceVariant,
                    )
                    Text(
                        text = lang.formatCount(recipe.likeCount),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }

            // ── Story card (the "gem" flavor) — only when authored.
            recipe.story?.resolve(lang)?.takeIf { it.isNotBlank() }?.let { story ->
                AppCard {
                    Column(
                        modifier = Modifier.padding(AppTheme.spacing.lg),
                        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                        ) {
                            AppIcon(name = "auto_stories", tint = AppTheme.colors.secondary)
                            Text(
                                text = stringResource(Res.string.gems_story_title),
                                style = AppTheme.typography.headlineMd,
                                color = AppTheme.colors.onSurface,
                            )
                        }
                        Text(
                            text = story,
                            style = AppTheme.typography.bodyMd,
                            color = AppTheme.colors.onSurfaceVariant,
                        )
                    }
                }
            }

            // ── Stat tiles: prep / cook / serves + difficulty pill.
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                StatTile(
                    iconName = "timer",
                    label = stringResource(Res.string.gems_stat_prep),
                    value = stringResource(
                        Res.string.gems_minutes,
                        lang.localizeDigits(recipe.prepMinutes.toString()),
                    ),
                    modifier = Modifier.weight(1f),
                )
                StatTile(
                    iconName = "skillet",
                    label = stringResource(Res.string.gems_stat_cook),
                    value = stringResource(
                        Res.string.gems_minutes,
                        lang.localizeDigits(recipe.cookMinutes.toString()),
                    ),
                    modifier = Modifier.weight(1f),
                )
                StatTile(
                    iconName = "group",
                    label = stringResource(Res.string.gems_stat_serves),
                    value = lang.formatCount(recipe.servings),
                    modifier = Modifier.weight(1f),
                )
            }
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                Text(
                    text = stringResource(Res.string.gems_stat_difficulty),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                AppChip(label = recipe.difficulty.label(), selected = true)
            }

            // ── Ingredients checklist (tappable — shopping-list behavior, local state).
            Text(
                text = stringResource(Res.string.gems_ingredients_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onSurface,
            )
            AppCard {
                Column(modifier = Modifier.padding(vertical = AppTheme.spacing.sm)) {
                    recipe.ingredients.forEachIndexed { index, ingredient ->
                        val checked = index in checkedIngredients
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable {
                                    checkedIngredients = if (checked) {
                                        checkedIngredients - index
                                    } else {
                                        checkedIngredients + index
                                    }
                                }
                                .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.xs),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                        ) {
                            Checkbox(
                                checked = checked,
                                onCheckedChange = null,
                                colors = CheckboxDefaults.colors(checkedColor = AppTheme.colors.primary),
                            )
                            Text(
                                text = ingredient.name.resolve(lang),
                                style = AppTheme.typography.bodyMd,
                                color = if (checked) AppTheme.colors.onSurfaceVariant else AppTheme.colors.onSurface,
                                modifier = Modifier.weight(1f),
                            )
                            Text(
                                text = ingredient.quantity.resolve(lang),
                                style = AppTheme.typography.bodySm,
                                color = AppTheme.colors.onSurfaceVariant,
                            )
                        }
                    }
                }
            }

            // ── Numbered steps.
            Text(
                text = stringResource(Res.string.gems_steps_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onSurface,
            )
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                recipe.steps.forEachIndexed { index, step ->
                    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                        Box(
                            modifier = Modifier
                                .size(AppTheme.sizes.avatarSm)
                                .background(AppTheme.colors.primaryContainer, AppTheme.shapes.pill),
                            contentAlignment = Alignment.Center,
                        ) {
                            Text(
                                text = lang.formatCount(index + 1),
                                style = AppTheme.typography.labelMd,
                                color = AppTheme.colors.onPrimaryContainer,
                            )
                        }
                        Text(
                            text = step.text.resolve(lang),
                            style = AppTheme.typography.bodyMd,
                            color = AppTheme.colors.onSurface,
                            modifier = Modifier.weight(1f),
                        )
                    }
                }
            }

            // ── CTAs.
            AppButton(
                text = stringResource(Res.string.gems_start_cooking),
                onClick = onStartCooking,
                leadingIcon = "skillet",
                modifier = Modifier.fillMaxWidth(),
            )
            recipe.groceryQuery?.let { query ->
                AppButton(
                    text = stringResource(Res.string.gems_find_ingredients),
                    onClick = { onFindIngredients(query) },
                    variant = AppButtonVariant.Secondary,
                    leadingIcon = "storefront",
                    modifier = Modifier.fillMaxWidth(),
                )
            }

            // ── Report link. QA 2026-09-12: it was unclickable — the last row of a scrolling column
            // sat under the floating bottom bar, and its hit rect was only the glyph height. Full
            // width, a ≥48dp target, and clearance below so it scrolls clear of the bar.
            Text(
                text = stringResource(Res.string.gems_report_action),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { showReportSheet = true }
                    .heightIn(min = AppTheme.sizes.minTouchTarget)
                    .wrapContentHeight(Alignment.CenterVertically),
            )
            Spacer(Modifier.height(AppTheme.sizes.bottomBarContentClearance))
        }
    }

    if (showReportSheet) {
        ReportSheet(
            title = stringResource(Res.string.gems_report_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.gems_report_reason_offensive), "offensive"),
                ReportReason(stringResource(Res.string.gems_report_reason_spam), "spam"),
                ReportReason(stringResource(Res.string.gems_report_reason_other), "other"),
            ),
            status = when (state.reportStatus) {
                GemReportStatus.Sending -> ReportStatus.Sending
                GemReportStatus.Sent -> ReportStatus.Sent
                GemReportStatus.Failed -> ReportStatus.Failed
                else -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.gems_report_sent),
            failedText = stringResource(Res.string.gems_report_failed),
            submitText = stringResource(Res.string.gems_report_submit),
            doneText = stringResource(Res.string.gems_report_done),
            onSubmit = onReport,
            onDismiss = {
                showReportSheet = false
                onResetReport()
            },
        )
    }
}

/** Circular surface-tinted icon button floating over the hero image. */
@Composable
private fun FloatingActionIcon(
    iconName: String,
    contentDescription: String,
    onClick: () -> Unit,
    filled: Boolean = false,
    tint: androidx.compose.ui.graphics.Color = AppTheme.colors.onSurface,
) {
    Box(
        modifier = Modifier
            .size(AppTheme.sizes.iconCircle)
            .background(AppTheme.colors.surface, AppTheme.shapes.pill),
        contentAlignment = Alignment.Center,
    ) {
        AppIconButton(
            iconName = iconName,
            contentDescription = contentDescription,
            onClick = onClick,
            filled = filled,
            tint = tint,
        )
    }
}

/** Hero image aspect (photo-forward 4:3 — matches the news detail hero treatment). */
private const val HERO_ASPECT_RATIO = 4f / 3f
